// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData__ContactData__3aTn7","Input":"ContactData__Input__bPRYS"};